import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { HttpInterceptorService, RESTService } from '@covalent/http';
import { MOCK_API } from '../config/api.config';
import { environment } from '../environments/environment';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { Alergia } from '../models/';

@Injectable()
export class AlergiasService extends RESTService<any> {

  public alergia: Alergia;

  constructor(private _http: HttpInterceptorService) {
    super(_http, {
      baseUrl: MOCK_API,
      path: '/resumenPaciente',
    });
  }

  /**
   * getAlergia: obtiene el listado completo de alergias de un paciente
   * @param pacienteId: string
   * @return any
   */
  obtenerAlergias(pacienteId: string): any {
    return this._http.post(environment.api_host + 'alergias/obtenerAlergias', {
      numeroExpediente: pacienteId,
    }).map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Service error'));
  }

 /**
  * guardarAlergia
  * @param params: object
  * @return boolean
  */
  guardarAlergia(params: any): Observable<string> {
    return this._http.post(environment.api_host + 'alergias/guardarAlergia', params).map((res: Response) => {
      let respuesta: any = res.json();
      if (respuesta.resultado !== undefined) {
        return respuesta.resultado;
      } else {
        return false;
      }
    }).catch((error: any) => Observable.throw(false));
  }

 /**
  * cambiarEstadoAlergia
  * @param params: object
  * @return boolean
  */
  cambiarEstadoAlergia(params: any): Observable<string> {
    return this._http.post(environment.api_host + 'alergias/cambiarEstadoAlergia', params).map((res: Response) => {
      let respuesta: any = res.json();
      if (respuesta.resultado !== undefined) {
        return respuesta.resultado;
      } else {
        return false;
      }
    }).catch((error: any) => Observable.throw(false));
  }

  borrarAlergia(params: any): Observable<string> {
     return this._http.post(environment.api_host + 'alergias/borrarAlergia', params).map((res: Response) => {
      let respuesta: any = res.json();
      if (respuesta.resultado !== undefined) {
        return respuesta.resultado;
      } else {
        return false;
      }
    }).catch((error: any) => Observable.throw(false));
  }
}



// WEBPACK FOOTER //
// ./src/services/alergias.service.ts